import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
import { getHeaders, checkStatus } from "../../../Services/SharedSevices/SharedServices";
  const baseURL = process.env.REACT_APP_BASE_URL;
  
  // For get the project details.
  export const getProjectDetails = async (body) => {
    try {
      const response = await axiosInstance.get(`${baseURL}/OrgProject/Project?ProjectId=${body.ProjectId}&OrgId=${body.OrgId}&LoggedInUserId=${body.LoggedInUserId}`, body, {
        headers: await getHeaders(),
        body: JSON.stringify(body)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

    // For get the project details.

    export const AddProjectAssignes = async (body) => {
      try {
        const response = await axiosInstance.post(`${baseURL}/OrgProject/ProjectAssignes`, body, {
          headers: await getHeaders(),
          body: JSON.stringify(body)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
    }

      // For get the project details.

      export const getAssignesProject = async (body) => {
        try {
          const response = await axiosInstance.get(`${baseURL}/OrgProject/ProjectAssignes?Id=${body.Id}&EmpId=${body.EmpId}`, body, {
            headers: await getHeaders(),
            body: JSON.stringify(body)
          });
          checkStatus(response);
          return response.data;
        } catch (error) {
          return Promise.reject(error);
        }
      }